/**
 * Configuración de una etapa del torneo
 * Se almacena en JSON en la tabla tournament_config
 */

export enum StageType {
  GROUPS = "GROUPS",
  KNOCKOUT = "KNOCKOUT",
  PLAYOFF = "PLAYOFF",
  LEAGUE = "LEAGUE",
}

export enum TieBreakerCriterion {
  // Por orden de precedencia
  GOAL_DIFFERENCE = "GOAL_DIFFERENCE",
  GOALS_FOR = "GOALS_FOR",
  HEAD_TO_HEAD = "HEAD_TO_HEAD",
  AWAY_GOALS = "AWAY_GOALS",
  FAIRPLAY = "FAIRPLAY", // Tarjetas
  RANDOM = "RANDOM",
}

export interface TieBreakerRule {
  criterion: TieBreakerCriterion;
  order: number;
}

export interface ScoringRules {
  pointsPerWin: number;
  pointsPerDraw: number;
  pointsPerLoss: number;
  tieBreakers: TieBreakerRule[];
}

export interface StageStructure {
  groupsCount?: number; // Solo si es tipo GROUPS
  teamsPerGroup?: number; // Solo si es tipo GROUPS
  knockoutRound?: string; // Solo si es tipo KNOCKOUT
  knockoutTeamsCount?: number; // Equipos que juegan esta ronda
  knockoutMatchesCount?: number; // Partidos/llaves de esta ronda
  isDoubleLeg: boolean; // ¿Ida y vuelta?
  hasExtraTime: boolean; // ¿Prórroga? (Solo Knockout)
  hasPenalties: boolean; // ¿Penaltis? (Solo Knockout)
}

export interface SportsAdvantage {
  enabled: boolean;
  sourceStageOrder: number; // Etapa de donde viene el mérito (ej: la 1)
  sourcePosition: number; // Posición que da la ventaja (ej: el 1º)
}

export interface StageProgression {
  promotedCount: number; // Cuántos pasan de esta etapa a la siguiente
  bestThirdsCount?: number; // Específico para el formato de 48 equipos (3º de grupos avanzan)
}

export interface SlotMapping {
  slot: string;
  source: "GROUP_RANK" | "BEST_THIRD";
  group?: string;
  rank?: number;
  pool?: string[];
}

export interface StageConfig {
  type: StageType;
  order: number; // 1, 2, 3... para saber la secuencia de etapas del torneo
  name: string;

  // Reglas de Puntuación
  rules: ScoringRules;

  // Configuración de Estructura
  structure: StageStructure;

  // Lógica de "Punto Invisible" / Ventaja Deportiva
  advantage?: SportsAdvantage;

  // Hacia dónde van los que clasifican
  progression: StageProgression;

  // Indica si esta etapa es de consolación/tercer puesto y no debe participar en el árbol principal de eliminatorias.
  isConsolation?: boolean;

  // mappings definidos por el formato para esta etapa
  mappings?: SlotMapping[];
}
